"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityActionCreators = exports.SecurityActionTypes = void 0;
var SecurityActionTypes;
(function (SecurityActionTypes) {
    SecurityActionTypes["ChangePassword"] = "Security.ChangePassword";
    SecurityActionTypes["AuthEnable"] = "Security.AuthEnable";
    SecurityActionTypes["AuthDisable"] = "Security.AuthDisable";
    SecurityActionTypes["GetLoginHistory"] = "Security.GetLoginHistory";
})(SecurityActionTypes = exports.SecurityActionTypes || (exports.SecurityActionTypes = {}));
class SecurityActionCreators {
}
exports.SecurityActionCreators = SecurityActionCreators;
SecurityActionCreators.changePassword = (changePassword) => ({
    type: SecurityActionTypes.ChangePassword,
    changePassword
});
SecurityActionCreators.authEnable = (token, secret) => ({
    type: SecurityActionTypes.AuthEnable,
    token,
    secret
});
SecurityActionCreators.authDisable = (token) => ({
    type: SecurityActionTypes.AuthDisable,
    token
});
SecurityActionCreators.getLoginHistory = (lastId) => ({
    type: SecurityActionTypes.GetLoginHistory,
    lastId
});
//# sourceMappingURL=security.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/actions/security.js
// module id = 106
// module chunks = 0